<div class="sidenav-content" cdkScrollable *ngIf="!submitting; else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
		[titleHeaderText]="('guarantee.register' | translate) + getLongType()">
		<button type="button" mat-flat-button (click)="saveGuarantee($event)" [disabled]="dialogRef !== undefined">
			<span translate>issue.save.as.drafts</span>
			<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button type="submit" mat-flat-button color="primary" (click)="submitGuarantee($event)" [disabled]="dialogRef !== undefined">
			<span translate>submit.guarantee.request</span>
		</button> 
	</copo-panel-header>
	<div class="copo-form-container">
		<copo-stepper class="copo-stepper-container" [steps]="steps" (stepClicked)="onStepClicked($event)">
		</copo-stepper>
		<button type="button" mat-icon-button (click)="print()" class="print-button" [disabled]="dialogRef !== undefined">
			<mat-icon svgIcon="md:print" class="print-icon"></mat-icon>
		</button>
	</div>
	<copo-guarantee-request-summary [guarantee]="guarantee" [showAdditionalDocuments]="true" (summaryElementsCreated)="onSummaryElementsCreated($event)"></copo-guarantee-request-summary>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>